export const getLocale = () => window.__WIX_LOCALE__;
export const getCorrectLocale = () => window.__LOCALE__;
